import * as React from 'react';
import cn from 'classnames';
import './AdBlock.css';

interface Props {
	size?: 'small' | 'medium';
}

const AdBlock: React.FC<Props> = props => {
	/*React.useEffect(() => {
		const installGoogleAds = () => {
			const elem = document.createElement("script");
			elem.src = "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
			elem.async = true;
			elem.defer = true;
			document.body.insertBefore(elem, document.body.firstChild);
		};
		installGoogleAds();

		((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
	}, []);*/

	return <></>;

	/*return (
		<div className={cn("adblock")}>
			<ins
				className="adsbygoogle"
				style={{
					display: "block",
				}}
				data-ad-client="ca-pub-5565173387901371"
				data-ad-slot="5866085564"
				data-ad-format="auto"
				data-full-width-responsive="true"
				data-adtest={process.env.NODE_ENV === "development" ? "on" : "off"}
			/>
		</div>
	);*/
};

export default AdBlock;
